export const SORT_BY_NUMBER = 'sortByNumber';
export const SORT_BY_ODD = 'sortByOdd';



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/constants/sortingTypes.js